import { useState } from 'react';

import { FieldInputProps } from 'react-final-form';

export function useNullableCard<T>({
  input,
  defaultValue,
}: {
  input: FieldInputProps<T | null>;
  defaultValue: T;
}): {
  isAdded: boolean;
  handleAdd: () => void;
  handleRemove: () => void;
} {
  const [isAdded, setIsAdded] = useState(input.value !== null);

  const handleAdd = (): void => {
    setIsAdded(true);
    input.onChange(defaultValue);
  };

  const handleRemove = (): void => {
    setIsAdded(false);
    input.onChange(null);
  };

  return { isAdded, handleAdd, handleRemove };
}
